import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { HttpClient, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { loginReducer } from './shared/store/user/user.reducer';
import { provideStore } from '@ngrx/store';


export const appConfig: ApplicationConfig = {
  providers: [
    provideStore({ ['loggedInUser']: loginReducer }),
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes), 
    provideClientHydration(),
    HttpClient,
    provideHttpClient(withFetch())
  ]
};
